export default {
  on: true,
  cache: true,
  auth: true,
  intercept: false,
  title: '品种组合转移',
} as TCommon.RouteConfig
